import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/app';
import { Provider } from 'react-redux';
import store from '../src/redux/store';
import reportWebVitals from './reportWebVitals';
import RTL from './components/RTL/RTL'
// import Layout from './components/layout'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import Themes from "./themes";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={Themes.default}>
        <RTL>
          <App />
        </RTL>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
